import React from 'react';
import './AppLoader.css';

/**
 * AppLoader — full-screen loading overlay shown while data syncs.
 * Props:
 *   appName  (string) – e.g. "Receptionist Portal"
 *   loading  (bool)   – controlled by context
 */
const AppLoader = ({ appName = 'SDT App', loading }) => {
    if (!loading) return null;

    return (
        <div className="app-loader-overlay">
            <div className="app-loader-brand">
                <div className="app-loader-logo">S</div>
                <span className="app-loader-appname">{appName}</span>
            </div>

            <div className="app-loader-ring-wrap">
                <div className="app-loader-ring" />
                <div className="app-loader-ring-inner" />
            </div>

            <div className="app-loader-text">
                <span className="app-loader-headline">Syncing your data</span>
                <span className="app-loader-sub">Please wait — loading live records</span>
                <div className="app-loader-dots">
                    <span /><span /><span />
                </div>
            </div>
        </div>
    );
};

export default AppLoader;
